'use strict';

// Constructor
var Services = function() {
  $('.view-id-taxonomy_term .inner').matchHeight();
};

module.exports = Services;
